import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsKomHighlightedXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.619.568a.875.875 0 00-1.238 0L3.578 4.37 1.291 3.202A.875.875 0 00.049 4.214l1.866 6.744h12.17l1.866-6.744a.875.875 0 00-1.242-1.012l-2.287 1.169zM5.854 6.146l1.792-1.793a.5.5 0 01.708 0l1.792 1.793a.5.5 0 010 .707L8.354 8.646a.5.5 0 01-.708 0L5.854 6.853a.5.5 0 010-.707zM13.958 12.209H2.042v1.124c0 .897.727 1.625 1.625 1.625h8.666c.898 0 1.625-.728 1.625-1.625z" />
      </g>
    </svg>
  )
);
SvgAchievementsKomHighlightedXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsKomHighlightedXsmall;
